import { NavigationAccordion, NavigationButton, NavigationLink, NavigationPanel } from '@hub/navigation';
import React from 'react';
import { isNavigationLink } from '../types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const AccordionMenu = _ref => {
  let {
    items,
    onClickLink,
    onClickButton
  } = _ref;
  let index = 0;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: items.map((item, key) => {
      if (isNavigationLink(item)) {
        return /*#__PURE__*/_jsx(NavigationLink, {
          size: "md",
          href: item.url,
          onClick: event => onClickLink === null || onClickLink === void 0 ? void 0 : onClickLink(event, [item]),
          "data-id": "header-menus_accordion-menu_AccordionMenu_NavigationLink",
          children: item.label
        }, key);
      }
      return /*#__PURE__*/_jsxs(NavigationAccordion, {
        index: index++,
        "data-id": "header-menus_accordion-menu_AccordionMenu_NavigationAccordion",
        children: [/*#__PURE__*/_jsx(NavigationButton, {
          onClick: (event, context) => {
            onClickButton === null || onClickButton === void 0 || onClickButton(event, context, [item]);
          },
          "data-id": "header-menus_accordion-menu_AccordionMenu_NavigationAccordion_NavigationButton",
          children: item.title
        }), /*#__PURE__*/_jsx(NavigationPanel, {
          "data-id": "header-menus_accordion-menu_AccordionMenu_NavigationAccordion_NavigationPanel",
          children: item.items.filter(isNavigationLink).map((childItem, key) => /*#__PURE__*/_jsx(NavigationLink, {
            size: "md",
            href: childItem.url,
            onClick: event => onClickLink === null || onClickLink === void 0 ? void 0 : onClickLink(event, [item, childItem]),
            "data-id": "header-menus_accordion-menu_AccordionMenu_NavigationLink",
            children: childItem.label
          }, key))
        })]
      }, key);
    })
  });
};